import PropTypes from 'prop-types';
const clickHandlerMapping = {
  onClick: 'onPress',
  onMouseDown: 'onPressIn',
  onMouseUp: 'onPressOut'
};
export default {
  /**
   * Web-oriented HTML click handlers that may be mapped to React Native press handlers
   */
  types: Object.fromEntries(Object.keys(clickHandlerMapping).map(mouseName => [mouseName, PropTypes.func])),
  /**
   * Takes a set of props and converts HTML mouse click oriented event handlers to closest
   * equivalent React Native press event handler.
   *
   * Use this when a component that expects press-oriented props may need to support third-party
   * web-oriented tooling that injects web-oriented event handlers directly. For example, for
   * to support use with NextJS's 'next/link' component, which injects `onClick` prop into its child.
   */
  toPressProps: props => Object.fromEntries(Object.entries(props).map(_ref => {
    let [originalName, value] = _ref;
    const translatedName = clickHandlerMapping[originalName];
    return translatedName ? [translatedName, value] : [originalName, value];
  }))
};